/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { APIs } from 'src/models/apis';
import { useQuery } from 'react-query';
import { useAPIs } from 'src/hooks/useAPIs';
import { QueryKey } from 'src/models/query';
import { DictionaryCode } from 'src/models/pim/dictionaries';

export const fetchDictionaryDetailsQuery = (
  apis: APIs,
  code: DictionaryCode,
) => ({
  queryKey: [...QueryKey.DictionaryDetails, code],
  queryFn: () => apis.pim.dictionaries.details(code),
});

export const useDictionaryDetailsQuery = (code: DictionaryCode) => {
  const apis = useAPIs();

  return useQuery(fetchDictionaryDetailsQuery(apis, code));
};
